<div id="loading-wrapper" #loading>
    <img #image id="loading" src="assets/img/icon_round.png" alt="loading" width="120px" />
    <ion-backdrop class="backdrop"></ion-backdrop>
</div>
